module.exports = __webpack_public_path__ + "img/qr-logo.f649eb8a.png";